import { reducer } from './widget_reducer';

export default reducer;
